<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Kategori</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'skd_category'}">Data Kategori</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-12">
                                            <label>Nama</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-12 mt-3">
                                            <label>Deskripsi</label>
                                            <textarea
                                                rows="4"
                                                class="form-control"
                                                placeholder="Masukan data..." v-model="form.description" :class="{ 'is-invalid': submitted && $v.form.description.$error }">
                                            </textarea>
                                            <div v-if="submitted && !$v.form.description.required" class="invalid-feedback">Deskripsi Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-12 mt-3">
                                            <label>Passing Grade</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.passing_grade" :class="{ 'is-invalid': submitted && $v.form.passing_grade.$error }">
                                            <div v-if="submitted && !$v.form.passing_grade.required" class="invalid-feedback">Passing Grade Wajib diisi!</div>    
                                            <div v-if="submitted && !$v.form.passing_grade.numueric" class="invalid-feedback">Passing Grade Harus Berupa Angka!</div>    
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'skd_category'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required, numeric
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'Category',
        metaInfo: {
            title: 'Form Kategori',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        created() {
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id      : "",
                    name    : "",
                    description : "",
                    passing_grade : "",
                },
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
                description: {
                    required
                },
                passing_grade: {
                    required,
                    numeric
                },
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('name', this.form.name);
                    formData.append('description', this.form.description);
                    formData.append('passing_grade', this.form.passing_grade);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/category/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'skd_category' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/category/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id                = getResponse.id;
                            this.form.name              = getResponse.name;
                            this.form.description       = getResponse.description;
                            this.form.passing_grade     = getResponse.passing_grade;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'skd_category' });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
</script>